import { defineNuxtPlugin } from 'nuxt/app'
import { useCookieStore } from '~/store/cookiesStore'
import { useGlobalStore } from '~/store'
import { useLocalModalStore } from '~/store/localeModalStore'
import { useSiteMeasurementStore } from '~/store/siteMeasurementStore'
import { useUserStore } from '~/store/userStore'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      store: {
        ...useGlobalStore(),
        cookies: useCookieStore(),
        localModal: useLocalModalStore(),
        siteMeasurement: useSiteMeasurementStore(),
        user: useUserStore(),
      },
    },
  }
})
